import type {
    IPhieuXuatKhoSelectedKhoLine,
    PhieuXuatKhoTableRow,
} from "../types";
import { isFooterRow } from "./usePhieuXuatKhoTableCellApi";

export type NormalizedRowKind = "data" | "footer-total" | "footer-text";

export function isThuHoiVatTu(value: unknown): boolean {
  return value === true || value === 1 || value === "1";
}

export interface NormalizedPhieuXuatKhoRow {
  kind: NormalizedRowKind;
  idVatTu?: number;
  tenVatTu?: string;
  maVatTu?: string;
  donViTinh?: string;
  tonKho?: number;
  soLuongXuat?: number;
  donGia?: number;
  ghiChu?: string;
  thuHoi?: boolean;
  canEditThuHoiFields?: boolean;
  slTaiSd?: number;
  slMat?: number;
  slPheLieu?: number;
  kgPheLieu?: number;
  maVtThuHoi?: string;
  footerMeta?: {
    tongTienBangChu?: string;
    vatTuDaLay?: { don_gia: number; so_luong_lay: number }[];
  };
}

export function summaryLineToTableRow(
  line: IPhieuXuatKhoSelectedKhoLine
): PhieuXuatKhoTableRow {
  return {
    ...line,
    so_luong_xuat: line.so_luong_lay,
    so_luong_ton: line.con_lai,
  };
}

export function normalizeTableRow(
  row: PhieuXuatKhoTableRow
): NormalizedPhieuXuatKhoRow {
  if (isFooterRow(row)) {
    return {
      kind: row._footerType === "total" ? "footer-total" : "footer-text",
      footerMeta: {
        tongTienBangChu: row.tong_tien_bang_chu,
        vatTuDaLay: row.vat_tu_da_lay,
      },
    };
  }

  const line = row as Partial<IPhieuXuatKhoSelectedKhoLine> & {
    id?: number;
    id_vat_tu?: number;
    con_lai?: number;
    so_luong_ton?: number;
    so_luong_xuat?: number;
    thu_hoi?: unknown;
    vat_tu_thu_hoi?: { ma_vat_tu?: string } | null;
  };

  const idVatTu =
    typeof line.id === "number"
      ? line.id
      : typeof line.id_vat_tu === "number"
        ? line.id_vat_tu
        : undefined;
  const thuHoi = isThuHoiVatTu(line.thu_hoi);

  return {
    kind: "data",
    idVatTu,
    tenVatTu: line.ten_vat_tu,
    maVatTu: line.ma_vat_tu,
    donViTinh: line.don_vi_tinh,
    tonKho: line.con_lai ?? line.so_luong_ton,
    soLuongXuat: line.so_luong_lay ?? line.so_luong_xuat,
    donGia: line.don_gia,
    ghiChu: line.ghi_chu,
    thuHoi,
    canEditThuHoiFields: thuHoi,
    slTaiSd: line.sl_tai_sd,
    slMat: line.sl_mat,
    slPheLieu: line.sl_phe_lieu,
    kgPheLieu: line.kg_phe_lieu,
    maVtThuHoi:
      line.ma_vt_thu_hoi ?? line.vat_tu_thu_hoi?.ma_vat_tu ?? undefined,
  };
}
